import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {Organization} from "../api";

export class OrganizationService extends RestService<Organization> {
    constructor(url?) {
        if (url) {
            super(url)
        } else {
            super(REST_API_END_POINTS.ORGANIZATIONS)
        }
    }

    expected_delivery_date() {
        return this.instance.get(`${this.url}expected_delivery_date/`)
    }

    send_test_email() {
        return this.instance.get(`${this.url}send_test_mail/`)
    }

    average_service_time(code) {
        return this.instance.get(`${this.url}average_service_time/${code}/`)
    }

    send_flash_message(values) {
        return this.instance.post(`${this.url}send_flash_message/`, values)
    }

    guess_my_location(values) {
        return RestService.call_url_action<Organization>(
            `${this.url}guess_my_location/`, 'POST', values
        )
    }

    add_bank_details(values) {
        return RestService.call_url_action(
            `${this.url}add_bank_details/`, "POST", values)
    }
}
